<template>
  <div
    v-if="gantryAccessQrEnabled && qrCodeEntry"
  >
    <div>
      <v-card
        height="104px"
        style="border-radius: 0px"
        color="primary"
        class="pr-1"
      >
        <!-- Toolbar -->
        <v-toolbar
          id="newBookingToolbar"
          dark
          elevation="0"
          color="primary"
          style="border-bottom-right-radius: 5px; border-bottom-left-radius: 5px"
        >
          <img
            :src="`${this.iconPath}nlb-logo-white.png`"
            style="height: 48px; widthx: 24px"
            class="mr-3"
          />

          <v-toolbar-title>QR Code Day Pass</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="confirmLogout">
            <v-icon>mdi-logout-variant</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-card
          class="mx-2 px-5 pt-8 pb-3 mb-2"
          style="border-radius: 8px"
        >
          <div class="text-center pt-4 pb-10">
            <figure class="qrcode">
              <qrcode-vue :value="qrCodeEntry" :size="160" level="H" />
                <img
                  :src="`${this.iconPath}nlb-daypass-logo.png`"
                  style="height: 50px; width: 50px"
                  class="qrcode__image"
                />
            </figure>
          </div>
          <div class="text-title text-center">
            Please scan this QR code to enter and exit the library.
          </div>
          <div class="text-title text-center pt-2">
            QR code is valid for today
          </div>
          <div class="text-title text-center">
            {{ formatCurrentDate() }}
          </div>
        </v-card>
      </v-card>
    </div>
    <div id="bottomNavigation">
      <v-bottom-navigation
        v-show="true"
        fixed
        grow
        color="primary"
        style="height: auto"
        block
      >
        <v-btn>
          <span>QR Code</span>
          <v-icon>mdi-qrcode</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import { mapGetters, mapState } from 'vuex';
import formatters from "@/helpers/formatters";

export default {
  name: 'GantryAccessQR',
  components: {
    QrcodeVue,
  },
  computed: {
    ...mapState(["qrCode", "qrCodeEntry"]),
    ...mapGetters(["authenticated", "visitBookingEnabled", "gantryAccessQrEnabled"]),
  },
  methods: {
    confirmLogout() {
      const yesCallback = async () => {
        this.logout();
      };

      this.updateSystemDialog({
        title: window.$msg.confirmLogout,
        // message: window.$msg.confirmLogout,
        actions: {
          actionType: "YesOrNo",
          yes: {
            callback: yesCallback,
          },
        },
      });
    },
    formatCurrentDate() {
      return formatters.formatCurrentDate();
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.authenticated && vm.gantryAccessQrEnabled && vm.qrCodeEntry) {
        next()
      }
      else {
        return next({ name: "EmailMobileLogin" });
      }
    });
  },
}
</script>

<style scoped>
.qrcode {
  display: inline-block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
}
/* Fix bottom-navigation button floting up issue */
#bottomNavigation .v-btn:not(.v-btn--round).v-size--default {
  height: auto;
}

#bottomNavigation,
#bottomNavigation .v-icon {
  font-size: 20px;
}

#bottomNavigation .v-icon {
  margin-bottom: 2px;
}

#bottomNavigation .v-btn {
  padding-top: 7px;
  padding-bottom: 5px;
  background-color:white;
}

#bottomNavigation .v-item-group.v-bottom-navigation .v-btn {
  font-size: 12px !important;
}

.qrcode__image {
  background-color: #fff;
  border: 0.25rem solid #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
  height: 15%;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15%;
}
</style>

<style>
#newBookingToolbar .v-toolbar__content,
.v-toolbar__extension {
  padding-left: 10px !important;
}
</style>
